// src/app/services/gasHeaterApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IGasHeater, IGasHeaterParams } from '../models';

export const gasHeaterApi = createApi({
  reducerPath: 'gasHeaterApi',
  baseQuery,
  endpoints: (builder) => ({
    getGasHeaterParams: builder.query<{ gas_heater: IGasHeaterParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/gas_heaters/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getGasHeater: builder.query<IGasHeater, number>({
      query: (id) => `/api/v1.0/ahu/gas_heaters/${id}`,
    }),
  }),
});

export const { useLazyGetGasHeaterQuery, useGetGasHeaterParamsQuery } =
  gasHeaterApi;
